var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "section",
    { staticClass: "covid-notice" },
    [
      _vm._m(0),
      _vm._v(" "),
      _c("p", [
        _vm._v(
          "\n      Com a Donamaid, os profissionais autônomos de limpeza são amparados e orientados à prevenção ao coronavírus. Você também deve se prevenir. Juntos seremos mais fortes. \n    "
        )
      ]),
      _vm._v(" "),
      _c(
        "button",
        {
          staticClass: "btn bg-pink-reverse auto",
          on: {
            click: function($event) {
              _vm.show = !_vm.show
            }
          }
        },
        [_vm._v("\n      veja as orientações\n    ")]
      ),
      _vm._v(" "),
      _c("transition", { attrs: { name: "fade" } }, [
        _vm.show
          ? _c("div", { staticClass: "root" }, [
              _vm.show
                ? _c("div", { staticClass: "container" }, [
                    _c("h5", { staticClass: "title" }, [
                      _vm._v(
                        "\n\t\t\t\t\t\tProtocolo para prevenção contra o coronavírus\n\t\t\t\t\t"
                      )
                    ]),
                    _vm._v(" "),
                    _c("p", { staticClass: "message" }, [
                      _c("b", [_vm._v("Máscaras e luvas")]),
                      _c("br"),
                      _vm._v(
                        "\n\t\t\t\t\t\tOs profissionais autônomos de limpeza são orientados a usar máscara e luvas durante todo o período da limpeza.\n\t\t\t\t\t\tÉ possível verificar os profissionais que estão comprometidos observando o selo “USO DE EPIs” em suas fotos no momento de contratar.\n\t\t\t\t\t"
                      )
                    ]),
                    _vm._v(" "),
                    _c("p", { staticClass: "message" }, [
                      _c("b", [
                        _vm._v(
                          "Minimize o contato entre você e o profissional e use máscara durante o período da limpeza"
                        )
                      ]),
                      _c("br"),
                      _vm._v(
                        "\n\t\t\t\t\t\tQuando o profissional chegar, cumprimente-o apenas com palavras e sem cumprimento físico. Mantenha-se mais distante do profissional como, por exemplo, ficar em um cômodo separado do qual está sendo limpo pelo profissional. \n\t\t\t\t\t"
                      )
                    ]),
                    _vm._v(" "),
                    _c("p", { staticClass: "message" }, [
                      _c("b", [_vm._v("Higienize frequentemente as mãos")]),
                      _c("br"),
                      _vm._v(
                        "\n\t\t\t\t\t\tHigienize suas mãos com água e sabão, por aproximadamente\t60 segundos, sempre antes de se alimentar ou tocar em áreas do rosto como boca, nariz e olhos. Também, repita esse processo sempre que possível após tocar em objetos de fora da sua casa ou após trazer as compras para dentro de casa. Caso não tenha acesso a água e sabão, utilize álcool gel 70 para higienizar as mãos.\n\t\t\t\t\t"
                      )
                    ]),
                    _vm._v(" "),
                    _c("p", { staticClass: "message" }, [
                      _c("b", [_vm._v("Ambiente arejado")]),
                      _c("br"),
                      _vm._v(
                        "\n\t\t\t\t\t\tO ar circulante consegue reduzir a concentração de qualquer vírus que possa estar circulando no local. Mantenha as janelas dos ambientes abertas para que o ar circule e mantenha todo o ambiente arejado.\n\t\t\t\t\t"
                      )
                    ]),
                    _vm._v(" "),
                    _c("p", { staticClass: "message" }, [
                      _c("b", [_vm._v("Cuide da sua saúde")]),
                      _c("br"),
                      _vm._v(
                        "\n\t\t\t\t\t\tSe você ou qualquer pessoa do seu convívio diário apresentar sintomas ou estiver com COVID-19, solicite o cancelamento da sua limpeza agendada. Também é possível deixar como crédito para reagendar para o futuro.\n\t\t\t\t\t"
                      )
                    ]),
                    _vm._v(" "),
                    _c("h5", { staticClass: "title" }, [
                      _vm._v(
                        "\n\t\t\t\t\t\tAtualizações da Donamaid\n\t\t\t\t\t"
                      )
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "orientacoes" }, [
                      _c("p", { staticClass: "message" }, [
                        _vm._v(
                          "\n              Uma limpeza completa é essencial para manter o ambiente limpo e superar o coronavírus.\n            "
                        )
                      ]),
                      _vm._v(" "),
                      _c("p", { staticClass: "message" }, [
                        _vm._v(
                          "\n              Estamos operando o aplicativo normalmente, no entanto, com adições de novos protocolos voltados para a segurança tanto de clientes quanto dos profissionais. Orientamos sobre os sintomas e informamos sobre as medidas para conscientizar a todos.\n            "
                        )
                      ]),
                      _vm._v(" "),
                      _c("p", { staticClass: "message" }, [
                        _c("b", [
                          _vm._v(
                            "É possível eu seguir contratando os profissionais disponíveis no aplicativo?"
                          )
                        ])
                      ]),
                      _vm._v(" "),
                      _c("p", { staticClass: "message" }, [
                        _vm._v(
                          "\n              O serviço pode seguir ocorrendo se:\n            "
                        )
                      ]),
                      _vm._v(" "),
                      _c("ul", [
                        _c("li", [
                          _vm._v(
                            " Você ou as pessoas que residem ou frequentam o local não estão com os sintomas ou contaminados pelo COVID-19"
                          )
                        ]),
                        _vm._v(" "),
                        _c("li", [
                          _vm._v(
                            "O profissional autônomo ou seus familiares não estiverem com os sintomas ou contaminados pelo COVID-19"
                          )
                        ])
                      ]),
                      _vm._v(" "),
                      _c("p", { staticClass: "message" }, [
                        _vm._v(
                          "\n              O profissional autônomo de limpeza recebeu orientações extras que eles devem tomar durante esse período. Tais orientações podem ser encontrados aqui:\n            "
                        )
                      ]),
                      _vm._v(" "),
                      _c("ul", [
                        _c("li", [
                          _vm._v(
                            "Utilizar máscaras e luvas durante toda a limpeza"
                          )
                        ]),
                        _vm._v(" "),
                        _c("li", [
                          _vm._v(
                            "Trocar de roupas e sapatos logo que chegar ao local da limpeza"
                          )
                        ]),
                        _vm._v(" "),
                        _c("li", [
                          _vm._v(
                            "Higienizar bolsas e mochilas com álcool líquido 70 antes de entrar no local da limpeza"
                          )
                        ])
                      ]),
                      _vm._v(" "),
                      _c("p", { staticClass: "message" }, [
                        _vm._v(
                          "\n              Os profissionais que estão comprometidos com as orientações extras podem ser encontrados com o selo “USO DE EPIs” em suas fotos no agendamento no aplicativo. Novas medidas de biossegurança estão sendo introduzidas.\n            "
                        )
                      ]),
                      _vm._v(" "),
                      _c("p", { staticClass: "message" }, [
                        _c("b", [
                          _vm._v("Como estamos reforçando a segurança?")
                        ])
                      ]),
                      _vm._v(" "),
                      _c("p", { staticClass: "message" }, [
                        _vm._v(
                          "\t\n              Oferecemos orientações e materiais de medidas preventivas a serem tomadas, sempre registrando o comprometimento do colaborador.\n              Dentre elas, estão:\n            "
                        )
                      ]),
                      _vm._v(" "),
                      _c("ul", [
                        _c("li", [
                          _vm._v(
                            "Solicitamos que se o profissional estiver com sintomas de COVID-19 seja solicitado o reagendamento ou troca da limpeza"
                          )
                        ]),
                        _vm._v(" "),
                        _c("li", [
                          _vm._v(
                            "Orientamos os profissionais que apliquem as medidas de precauções e implementem o protocolo específico de COVID-19"
                          )
                        ])
                      ])
                    ])
                  ])
                : _vm._e(),
              _vm._v(" "),
              _c(
                "button",
                {
                  staticClass: "btn bg-pink auto",
                  on: {
                    click: function($event) {
                      _vm.show = !_vm.show
                    }
                  }
                },
                [_vm._v("\n            fechar e continuar\n          ")]
              )
            ])
          : _vm._e()
      ])
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("section", { staticClass: "title-covid-notice" }, [
      _c("h3", [_vm._v("Orientações sobre o coronavírus")])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-010d2ea6", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-010d2ea6","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/PurchaseFlow/CovidNotice.vue
// module id = null
// module chunks = 